import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-project-details-risk',
  templateUrl: './project-details-risk.component.html',
  styleUrls: ['./project-details-risk.component.scss']
})
export class ProjectDetailsRiskComponent implements OnInit {

  private projectId : string;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.paramMap.get('projectId');
  }

}
